module.exports = __webpack_public_path__ + "static/media/LocalLodging.2a61b6c3.svg";